export const LockIcon = ({ fill = '#2A9C4A' }: { fill?: string }) => {
  return (
    <svg
      aria-hidden='true'
      xmlns='http://www.w3.org/2000/svg'
      width='11'
      height='13'
      viewBox='0 0 11 13'
      fill='none'
    >
      <path
        fillRule='evenodd'
        clipRule='evenodd'
        d='M5.49997 1.85714C4.48745 1.85714 3.66664 2.68861 3.66664 3.71429V4.64286H7.33331V3.71429C7.33331 2.68861 6.51249 1.85714 5.49997 1.85714ZM1.83331 3.71429V4.64286H1.375C0.615606 4.64286 0 5.26646 0 6.03571V11.6071C0 12.3764 0.615606 13 1.375 13H9.625C10.3844 13 11 12.3764 11 11.6071V6.03571C11 5.26646 10.3844 4.64286 9.625 4.64286H9.16667V3.71429C9.16667 1.66294 7.52502 0 5.49997 0C3.47493 0 1.83331 1.66294 1.83331 3.71429Z'
        fill={fill}
      />
    </svg>
  )
}
